import { Head, Link } from "@inertiajs/react"

import { useAuth } from "@/hooks/use-auth"
import { dashboardPath, signInPath, signUpPath } from "@/routes"

export default function Welcome() {
  const { isAuthenticated } = useAuth()

  return (
    <>
      <Head title="Welcome" />

      <div className="bg-primary flex min-h-screen items-center justify-center px-4">
        <div className="max-w-2xl text-center">
          <h1 className="text-primary mb-4 text-4xl font-bold">
            Build confidence to talk about what&apos;s going on
          </h1>
          <p className="text-secondary mb-8 text-lg">
            Practice conversations in a safe space. Get comfortable expressing
            your thoughts and feelings before reaching out for support.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              href={isAuthenticated ? dashboardPath() : signUpPath()}
              className="bg-brand-600 hover:bg-brand-700 rounded-lg px-6 py-3 font-semibold text-white transition-colors"
            >
              Get Started
            </Link>
            {!isAuthenticated && (
              <Link
                href={signInPath()}
                className="bg-secondary text-primary hover:bg-tertiary rounded-lg px-6 py-3 font-semibold transition-colors"
              >
                Log in
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
